import { defaultResource, resourceFromAttributes } from '@opentelemetry/resources';
import type { Resource } from '@opentelemetry/resources';
import { ATTR_DEPLOYMENT_ENVIRONMENT, ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions/incubating';

import type { OtelSignalConfig } from '../types/otel-signal-config';

export function createResource({ serviceName, environment }: OtelSignalConfig): Resource {
  return defaultResource().merge(
    resourceFromAttributes({
      [ATTR_SERVICE_NAME]: serviceName,
      // Our base14 filters key off `deployment.environment` (ATTR_DEPLOYMENT_ENVIRONMENT),
      // not the newer `deployment.environment.name` (ATTR_DEPLOYMENT_ENVIRONMENT_NAME).
      [ATTR_DEPLOYMENT_ENVIRONMENT]: environment,
    }),
  );
}
